// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_LEX: 'IwZNfn1orm1ZcZ2Bbick1D4vSAjmxSg5iZTcofYg',
  URL: 'https://1oje5iir87.execute-api.us-east-1.amazonaws.com/default/CM-mkt-bot-gateway',
  LAMBDA_FUNCTION_URL: 'https://v6btanob3cdcotvm5ruhti6rpq0ynavz.lambda-url.us-east-1.on.aws/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
